"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = require("react-jss");

var _artiwebDefaultThemeDark = _interopRequireDefault(require("../ArtiwebThemes/artiwebDefaultThemeDark"));

var _artiwebDefaultTheme = _interopRequireDefault(require("../ArtiwebThemes/artiwebDefaultTheme"));

/**
 * Create a [JSS](https://cssinjs.org) Theme Provider using the Pre-defined ArtiWeb Themes or provide a custom theme.
 * The library uses JSS to generate all the Components styles, this component is just a wrapper of the 
 * JSS `<ThemeProvider>` Component with pre-defined themes.
 */
var ArtiwebThemeProvider = /*#__PURE__*/_react["default"].forwardRef(function ArtiwebThemeProvider(props, ref) {
  var Theme = props.Theme,
      children = props.children;
  var SelectedTheme;

  if ((0, _typeof2["default"])(Theme) === 'object' && Theme !== null) {
    SelectedTheme = Theme;
  } else {
    if (Theme === 'dark') {
      SelectedTheme = _artiwebDefaultThemeDark["default"];
    } else {
      SelectedTheme = _artiwebDefaultTheme["default"];
    }
  }

  return /*#__PURE__*/_react["default"].createElement(_reactJss.ThemeProvider, {
    theme: SelectedTheme
  }, children);
});

ArtiwebThemeProvider.defaultProps = {
  Theme: 'default'
};
process.env.NODE_ENV !== "production" ? ArtiwebThemeProvider.propTypes = {
  /**
   * Select a Default theme [Styling ](#DefaultThemes) or pass your theme as an object
   */
  Theme: _propTypes["default"].any
} : void 0;
var _default = ArtiwebThemeProvider;
exports["default"] = _default;